import { Button, Grid, Paper, Typography } from "@mui/material";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";
import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage: React.FC = () => {
  return (
    <div>
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: "center",
          maxWidth: 600,
          borderRadius: "0.75rem",
        }}
      >
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <ErrorOutlineIcon
              sx={{
                fontSize: 80,
                color: "error.main",
                marginBottom: 2,
              }}
            />
          </Grid>
          <Grid item>
            <Typography
              variant="h4"
              sx={{
                marginBottom: 2,
                fontWeight: 600,
              }}
            >
              401 - Unauthorized
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="body1"
              sx={{
                marginBottom: 4,
              }}
            >
              You don't have permission to access this page. Please contact your
              administrator if you believe this is an error.
            </Typography>
          </Grid>
          <Grid item>
            <Button
              component={Link}
              to="/meltshop-dashboard"
              variant="contained"
              color="primary"
              sx={{
                marginTop: 2,
              }}
            >
              Go to Dashboard
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default UnauthorizedPage;
